// constants/toastIcons.ts
import { ToastType } from "@/types/toast";

export const ToastIcons: Record<ToastType, string> = {
  [ToastType.Success]: "mdi-check-circle",
  [ToastType.Error]: "mdi-alert-circle",
  [ToastType.Warning]: "mdi-alert",
  [ToastType.Info]: "mdi-information",
};
